import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { CriteriaSuggestion, FilterType, FilterTypeCriteria, FilterTypes, Term } from '../../edit/edit-userfilter/edit-userfilter.component';
import { USERFILTER_FORMGROUP } from '../user-filter-dialog/classes';
import { FilterConditionsFormComponentService } from './filter-conditions-form-component-service';

@Component({
  selector: 'app-filter-conditions-form',
  templateUrl: './filter-conditions-form.component.html',
  styleUrls: ['./filter-conditions-form.component.css'],
  providers: [ FilterConditionsFormComponentService ]
})
export class FilterConditionsFormComponent implements OnDestroy, OnInit {

  statementValid: boolean = true;
  corruptedConstantInStatement: boolean = false;
  currentFilterType: FilterType<number>;
  compiledStatement: Term[];
  currentSuggestions = [{ title: "Aktiv", value: 1 }];

  lastInterpretation = null;

  filtercriteriaControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(USERFILTER_FORMGROUP) public formGroup: FormGroup,
    private _dataService: DataService,
    public filterConfitionsFormComponentService: FilterConditionsFormComponentService,
    private _injector: Injector
  ) { }

  addCriteria(criteria: FilterTypeCriteria<number>) {
    this.currentSuggestions = [];
    if (criteria.suggestionsProvider) criteria.suggestionsProvider(criteria, this._injector).subscribe((result) => this.currentSuggestions = result);
    else {
      let input = `"${criteria.value} = "`;
      let value = this.filtercriteriaControl.value;
      if (value) value += " & " + input;
      else value = input;
      this.filtercriteriaControl.setValue(value);
    }
  }
  
  addCriteriaValue(suggestion: CriteriaSuggestion<number>) {
    let input = "\"" + suggestion.criteria.value + " = " + suggestion.value + "\"";
    let value = this.filtercriteriaControl.value;
    if (value) value += " & " + input;
    else value = input;
    this.filtercriteriaControl.setValue(value);
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.filtertypeControl.valueChanges.subscribe((value: string) => this.setFilterType(value)),
      this.filtercriteriaControl.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
        let result = this.filterConfitionsFormComponentService.analyzeStatement(value);
        if(result) this.filterControl.setValue(result);
      })
    ]);
    this.setFilterType(this.filtertypeControl.value);
  }

  setFilterType = (type: string) => this.currentFilterType = FilterTypes.find(x => x.value === type);

  setTermOperator(operator: string, term: Term) {
    switch (operator) {
      case 'AND':
        if(term.node){
          term.node.fn = "bitAnd";
          term.node.op = "&";
        }
        break;
      case 'OR':
        if(term.node){
          term.node.fn = "bitOr";
          term.node.op = "|";
        }
        break;
    }
    if(this.lastInterpretation) this.filtercriteriaControl.setValue(this.lastInterpretation.toString());
  }

  get filtertypeControl(): AbstractControl {
    return this.formGroup.controls['filtertype'];
  }
  get filterControl(): AbstractControl {
    return this.formGroup.controls['filteR1'];
  }

}
